/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 */
import { orvalMutator } from "../config/orval/orvalMutator";

import type {
    GetApiInternalUser200,
    PostApiInternalUser200,
    PutApiInternalUser200,
    PutApiInternalUserBody,
} from "../../schemas";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * GetUser
 * @summary GetUser
 */
export const getApiInternalUser = (options?: SecondParameter<typeof orvalMutator>) => {
    return orvalMutator<GetApiInternalUser200>(
        { url: `/api/internal/user`, method: "GET" },
        options,
    );
};
/**
 * UpdateUser
 * @summary UpdateUser
 */
export const putApiInternalUser = (
    putApiInternalUserBody: PutApiInternalUserBody,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    const formData = new FormData();
    if (putApiInternalUserBody.active !== undefined) {
        formData.append(`active`, putApiInternalUserBody.active.toString());
    }
    if (putApiInternalUserBody.avatar_extension !== undefined) {
        formData.append(`avatar_extension`, putApiInternalUserBody.avatar_extension);
    }
    if (putApiInternalUserBody.avatar_id !== undefined) {
        formData.append(`avatar_id`, putApiInternalUserBody.avatar_id);
    }
    if (putApiInternalUserBody.balance !== undefined) {
        formData.append(`balance`, putApiInternalUserBody.balance.toString());
    }
    if (putApiInternalUserBody.contact !== undefined) {
        formData.append(`contact`, putApiInternalUserBody.contact);
    }
    if (putApiInternalUserBody.created_at !== undefined) {
        formData.append(`created_at`, putApiInternalUserBody.created_at);
    }
    if (putApiInternalUserBody.email !== undefined) {
        formData.append(`email`, putApiInternalUserBody.email);
    }
    if (putApiInternalUserBody.first_name !== undefined) {
        formData.append(`first_name`, putApiInternalUserBody.first_name);
    }
    if (putApiInternalUserBody.id !== undefined) {
        formData.append(`id`, putApiInternalUserBody.id);
    }
    if (putApiInternalUserBody.last_name !== undefined) {
        formData.append(`last_name`, putApiInternalUserBody.last_name);
    }
    if (putApiInternalUserBody.login !== undefined) {
        formData.append(`login`, putApiInternalUserBody.login);
    }
    if (putApiInternalUserBody.password !== undefined) {
        formData.append(`password`, putApiInternalUserBody.password);
    }
    if (putApiInternalUserBody.ru_account !== undefined) {
        formData.append(`ru_account`, putApiInternalUserBody.ru_account.toString());
    }
    if (putApiInternalUserBody.tutorial_completed !== undefined) {
        formData.append(`tutorial_completed`, putApiInternalUserBody.tutorial_completed.toString());
    }
    if (putApiInternalUserBody.avatar !== undefined) {
        formData.append(`avatar`, putApiInternalUserBody.avatar);
    }

    return orvalMutator<PutApiInternalUser200>(
        {
            url: `/api/internal/user`,
            method: "PUT",
            headers: { "Content-Type": "multipart/form-data" },
            data: formData,
        },
        options,
    );
};
/**
 * CreateUser
 * @summary CreateUser
 */
export const postApiInternalUser = (
    putApiInternalUserBody: PutApiInternalUserBody,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    const formData = new FormData();
    if (putApiInternalUserBody.active !== undefined) {
        formData.append(`active`, putApiInternalUserBody.active.toString());
    }
    if (putApiInternalUserBody.avatar_extension !== undefined) {
        formData.append(`avatar_extension`, putApiInternalUserBody.avatar_extension);
    }
    if (putApiInternalUserBody.avatar_id !== undefined) {
        formData.append(`avatar_id`, putApiInternalUserBody.avatar_id);
    }
    if (putApiInternalUserBody.balance !== undefined) {
        formData.append(`balance`, putApiInternalUserBody.balance.toString());
    }
    if (putApiInternalUserBody.contact !== undefined) {
        formData.append(`contact`, putApiInternalUserBody.contact);
    }
    if (putApiInternalUserBody.created_at !== undefined) {
        formData.append(`created_at`, putApiInternalUserBody.created_at);
    }
    if (putApiInternalUserBody.email !== undefined) {
        formData.append(`email`, putApiInternalUserBody.email);
    }
    if (putApiInternalUserBody.first_name !== undefined) {
        formData.append(`first_name`, putApiInternalUserBody.first_name);
    }
    if (putApiInternalUserBody.id !== undefined) {
        formData.append(`id`, putApiInternalUserBody.id);
    }
    if (putApiInternalUserBody.last_name !== undefined) {
        formData.append(`last_name`, putApiInternalUserBody.last_name);
    }
    if (putApiInternalUserBody.login !== undefined) {
        formData.append(`login`, putApiInternalUserBody.login);
    }
    if (putApiInternalUserBody.password !== undefined) {
        formData.append(`password`, putApiInternalUserBody.password);
    }
    if (putApiInternalUserBody.ru_account !== undefined) {
        formData.append(`ru_account`, putApiInternalUserBody.ru_account.toString());
    }
    if (putApiInternalUserBody.tutorial_completed !== undefined) {
        formData.append(`tutorial_completed`, putApiInternalUserBody.tutorial_completed.toString());
    }
    if (putApiInternalUserBody.avatar !== undefined) {
        formData.append(`avatar`, putApiInternalUserBody.avatar);
    }

    return orvalMutator<PostApiInternalUser200>(
        {
            url: `/api/internal/user`,
            method: "POST",
            headers: { "Content-Type": "multipart/form-data" },
            data: formData,
        },
        options,
    );
};
export type GetApiInternalUserResult = NonNullable<Awaited<ReturnType<typeof getApiInternalUser>>>;
export type PutApiInternalUserResult = NonNullable<Awaited<ReturnType<typeof putApiInternalUser>>>;
export type PostApiInternalUserResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalUser>>
>;
